'use strict';

import React, { Component } from 'react'

import AutoCompletedField from '@Pure/AutoCompletedField'

const app = window.app;

export default class SearchBar extends Component
{
	state =
	{
		value: this.props.defaultValue || ''
	};

	reset = (e) =>
	{
		const component = this, props = this.props;

		if (e)
		{
			e.preventDefault();

			app.emit('documentClick', component);
		}

		component.setState(
		{
			value: ''
		});

		if (typeof props.handleChange === 'function')
		{
			props.handleChange('', { name: props.name });
		}
	}

	handleChange = (e, data) =>
	{
		const component = this, props = this.props;

		var value;

		if (e)
		{
			value = e.target.value;
		}
		else
		{
			value = data.value;
		}

		component.setState(
		{
			value: value
		});

		if (typeof props.handleChange === 'function')
		{
			props.handleChange(value, data, e);
		}
	}

	render ()
	{
		const component = this, props = this.props;

		const value = props.value === undefined ? component.state.value : props.value;

		var button =
		(
			<button className="c-searchbar__btn" title="rechercher">
				OK
			</button>
		);

		if (props.hide_btn === true)
		{
			button = undefined;
		}

		var output =
		(
			<div className={ props.className || 'c-searchbar' }>
				<AutoCompletedField data={ props.data } id={ props.id || 1 }
					name={ props.name ||'search-page' }
					id_prefix={ props.id_prefix || 'page-search-' }
					onChange={ component.handleChange }
					onFocus={ props.onFocus }
					value={ value }
					placeholder={ ' ' + props.placeholder }
					alt_class="c-autocomplete--searchbar"
					autoFocus={ props.autoFocus }
				/>

				<label htmlFor={ (props.id_prefix || 'page-search-') + (props.id || 1) }>
					<svg className="o-svg-icon o-svg-icon--search c-searchbar__icon">
						<use xlinkHref="/images/icons.svg#svg-icon-search"></use>
					</svg>
				</label>

				{ button }

				<button className= { 'c-searchbar__reset' + (value !== '' ?
					' js-visible' : '') } onClick={ component.reset } title="effacer">
					<div className="c-searchbar__reset-icon"></div>
				</button>

			</div>
		);

		return output;
	}
}